import axios from 'axios';
import {backendHost} from '../../config';

export const postNewProviders = (params) => {
    return axios.post(`${backendHost}/api/admin/v2/games/providers`, params);
};